import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import SpecialistDashboard from "../pages/Manager/Dashboard/ManagerDashboard";
import Profile from "../pages/Manager/Profile/Profile";

var ManagerRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <SpecialistDashboard />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "manager",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ManagerRoutes;
